export default "__VITE_ASSET__acdff1dc__"